import React, { useEffect } from 'react'

import { LoginModalTypeEnum } from './login.enum'
import { LoginModalTemplateProps } from './login.types'
import LoginModalSubscribe from './login-modal-subscribe/LoginModalSubscribe'
import { LoginModalValidateDigitCode } from './login-modal-validate-digit-code/LoginModalValidateDigitCode'
import SubscribeFinalizedModal from './subscribe-finalized-modal/SubscribeFinalizedModal'
import SubscribeSimplifiedModal from './subscribe-simplified-modal/SubscribeSimplifiedModal'
import ForgotPassword from '../login-modal/forgot-password/forgot-password'
import LoginForm from '../login-modal/login-form/login-form'
import ResetPasswordForm from '../login-modal/reset-password/reset-password-form'
import { Mixpanel } from '../../../utils/Mixpanel'
import { pushToGTM } from '../../../utils/pushToGTM'

const EVENT_MAP: Record<
  LoginModalTypeEnum,
  { gtm: string; mp: { name: string; data: any } } | null
> = {
  [LoginModalTypeEnum.Login]: {
    gtm: 'LoginModalOpened',
    mp: {
      name: 'Login',
      data: {
        'Login Type': 'Email',
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.ForgotPassword]: {
    gtm: 'ForgotPasswordModalOpened',
    mp: {
      name: 'Forgot Password',
      data: {
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.ResetPassword]: {
    gtm: 'ResetPasswordModalOpened',
    mp: {
      name: 'Reset Password',
      data: {
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.Subscribe]: {
    gtm: 'SubscribeModalOpened',
    mp: {
      name: 'Subscribe',
      data: {
        'Subscribe Type': 'Form',
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.ValidateDigitCode]: {
    gtm: 'ValidateDigitCodeModalOpened',
    mp: {
      name: 'Validate Digit Code',
      data: {
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.SubscribeSimplified]: {
    gtm: 'SubscribeSimplifiedModalOpened',
    mp: {
      name: 'Subscribe',
      data: {
        'Subscribe Type': 'Simplified',
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.SubscribeFinalized]: {
    gtm: 'SubscribeFinalizedModalOpened',
    mp: {
      name: 'Subscribe Finalized',
      data: {
        'Subscribe Type': 'Finalized',
        type: 'modal',
        statut: 'open',
      },
    },
  },
  [LoginModalTypeEnum.Close]: null,
}

function useSendAnalyticsEventOnMount({
  type,
}: Pick<LoginModalTemplateProps, 'type'>) {
  useEffect(() => {
    const eventProps = EVENT_MAP[type as LoginModalTypeEnum]
    if (!eventProps) {
      return
    }
    pushToGTM({ event: eventProps.gtm })
    Mixpanel.track(eventProps.mp.name, eventProps.mp.data)
  }, [type])
}

const LoginModalTemplate = (props: LoginModalTemplateProps) => {
  const {
    type,
    forgotPasswordOptions,
    loginOptions,
    subscribeOptions,
    resetPasswordOptions,
    validateDigitCodeOptions,
    subscribeSimplifiedOptions,
    subscribeFinalizedOptions,
  } = props

  useSendAnalyticsEventOnMount(props)
  switch (type) {
    case LoginModalTypeEnum.Login:
      return <LoginForm {...loginOptions} />
    case LoginModalTypeEnum.ForgotPassword:
      return <ForgotPassword {...forgotPasswordOptions} />
    case LoginModalTypeEnum.ResetPassword:
      return <ResetPasswordForm {...resetPasswordOptions} />
    case LoginModalTypeEnum.Subscribe:
      return <LoginModalSubscribe {...subscribeOptions} />
    case LoginModalTypeEnum.ValidateDigitCode:
      return <LoginModalValidateDigitCode {...validateDigitCodeOptions} />
    case LoginModalTypeEnum.SubscribeSimplified:
      return <SubscribeSimplifiedModal {...subscribeSimplifiedOptions} />
    case LoginModalTypeEnum.SubscribeFinalized:
      return <SubscribeFinalizedModal {...subscribeFinalizedOptions} />
    default:
      return null
  }
}

export default LoginModalTemplate
